import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'
import dayjs from 'dayjs'

class PlanChangeHandling extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._id = init.id
    this._employee_id = init.employee_id
    this._client_name = init.client_name
    this._description = init.description
    this._effective_date = init.effective_date
    this._source_attachments = init.source_attachments
  }

  static shape = {
    id: PropTypes.number,
    employee_id: PropTypes.number,
    client_name: PropTypes.string,
    description: PropTypes.string,
    effective_date: PropTypes.string,
    source_attachments: PropTypes.array
  }

  get id() {
    return this._id
  }

  get employee_id() {
    return this._employee_id
  }

  get client_name() {
    return this._client_name
  }

  get description() {
    return this._description
  }

  get effective_date() {
    return this._effective_date
      ? dayjs(new Date(this._effective_date).toISOString())
      : null
  }

  get source_attachments() {
    return this._source_attachments
  }
}

export default PlanChangeHandling
